import { inject, Injectable } from '@angular/core';
import { UsersService } from '../http-services/users.service';
import { UserResponseModel } from '@itb-monorepo/models';
import { LanguageService } from './language.service';
import { AuthService } from './auth.service';

declare global {
  interface Window {
    $crisp: any[]; // Declare $crisp as an array of any type
    CRISP_WEBSITE_ID: string;
    CRISP_RUNTIME_CONFIG: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class CrispService {
  private userService = inject(UsersService);
  private languageService = inject(LanguageService);
  private authService = inject(AuthService);

  user: UserResponseModel;

  constructor() {
    let curLang = this.languageService.currentLang || 'en';

    // Wait until Crisp is loaded
    this.checkCrispLoaded().then(() => {
      if (this.authService.isAuthenticated) {
        this.userService
          .loadCurrentUser()
          .subscribe((user: UserResponseModel) => {
            this.user = user;
            this.sendUserData();
            this.setPosition();
          });
      }
    });

    this.languageService.getCurrentLanguage().subscribe((res: string) => {
      if (curLang != res) {
        this.renderCrisp(res);
        curLang = res;
      }
    });
  }

  // Function to check if Crisp is loaded
  checkCrispLoaded(): Promise<void> {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (window['$crisp']) {
          clearInterval(interval);
          resolve();
        }
      }, 500); // check every 500ms
    });
  }

  // Function to send user data to Crisp
  sendUserData(): void {
    // window['$crisp'].push(["do", "session:reset"]);
    window['$crisp'].push(['set', 'user:email', [this.user.email]]);
    window['$crisp'].push([
      'set',
      'user:nickname',
      [`${this.user.profile.first_name} ${this.user.profile.last_name}`],
    ]);

    // window['$crisp'].push(['set', 'language', "fr"]);
    // window['$crisp'].push(["set", "session:data", [[
    //     ["language", this.languageService.currentLang],
    //     ["url", location.href]
    // ]]]);
  }

  renderCrisp(language: string): void {
    window.CRISP_RUNTIME_CONFIG = {
      locale: language,
    };
    this.setPosition();
    this.resetCrisp();
  }

  setPosition(): void {
    const lang = this.languageService.currentLang;
    if (lang == 'fa' || lang == 'ar')
      window['$crisp'].push(['config', 'position:reverse', [true]]);
  }

  resetCrisp(): void {
    window['$crisp'].push(['do', 'session:reset']);
  }
}
